import React from "react";
import { navigate } from "gatsby";
import { Link } from "@chakra-ui/react";
import usePageContext from "context/PageContext";
import useStore from "context/StoreContext";

export const LanguagePicker = ({ ...cssprops }) => {
  let { unlocalizedSlug, lang } = usePageContext();
  const { updateCartLanguage } = useStore();

  if (!unlocalizedSlug) {
    unlocalizedSlug = "";
  }
  const nonActiveLang = lang === "en" ? "de" : "en";

  const slug = unlocalizedSlug.startsWith("/")
    ? unlocalizedSlug.substr(1)
    : unlocalizedSlug;

  const handleLanguageChange = async (e) => {
    e.preventDefault();

    await updateCartLanguage(nonActiveLang);

    navigate(`/${nonActiveLang}/${slug}`);
  };

  return (
    <Link
      textTransform="uppercase"
      as="button"
      onClick={handleLanguageChange}
      aria-label={`Change language to ${nonActiveLang}`}
      {...cssprops}
    >
      {nonActiveLang}
    </Link>
  );
};
